import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE } from "../api";
import "./Admin.css";

const AdminDashboard = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const fetchDashboard = async () => {
            console.log("--- ADMIN DASHBOARD START ---");
            const token = localStorage.getItem("token");
            if (!token) {
                console.warn("No token found, redirecting to login");
                window.location.href = "/#/admin/login";
                return;
            }

            try {
                console.log("Fetching dashboard stats from:", `${API_BASE}/api/admin/dashboard`);
                const response = await fetch(`${API_BASE}/api/admin/dashboard`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                console.log("HTTP Response Status:", response.status);

                if (response.status === 401) {
                    console.error("Unauthorized! Token might be expired.");
                    localStorage.removeItem("token");
                    window.location.href = "/#/admin/login";
                    return;
                }

                const data = await response.json();
                console.log("Full Stats Data Received:", data);
                setStats(data);
            } catch (error) {
                console.error("CRITICAL ERROR fetching dashboard:", error);
            } finally {
                console.log("--- ADMIN DASHBOARD END ---");
            }
        };

        fetchDashboard();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.href = "/#/admin/login";
    };

    // Helper to prevent "Objects are not valid as a React child"
    // Also handles DBNull serialized as {}
    const safeRender = (val) => {
        if (val === null || val === undefined) return "-";
        if (typeof val === 'object' && Object.keys(val).length === 0) return "-";
        if (typeof val === 'object') return JSON.stringify(val);
        return val;
    };

    const formatCurrency = (val) => {
        const num = Number(val);
        return isNaN(num) ? "₹0" : `₹${num.toLocaleString()}`;
    };

    if (!stats) return (
        <div className="lora-admin-body" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <p>Loading premium experience...</p>
        </div>
    );

    return (
        <div className="lora-admin-body">
            <div className="lora-admin-container">
                <header className="lora-admin-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <img src="./images/LEARNORAMA-LOGO.png" alt="Logo" style={{ width: '60px', borderRadius: '10px' }} />
                        <div>
                            <h2>Dashboard</h2>
                            <p style={{ color: 'var(--text-secondary)', margin: '5px 0 0 0' }}>Overview of your performance</p>
                        </div>
                    </div>
                    <button onClick={handleLogout} className="lora-admin-btn lora-admin-btn-logout">Logout</button>
                </header>

                <nav className="lora-admin-tabs">
                    <Link to="/admin/dashboard" className="lora-admin-tab active">Overview</Link>
                    <Link to="/admin/enrollments" className="lora-admin-tab">Enrollments</Link>
                    <Link to="/admin/transactions" className="lora-admin-tab">Transactions</Link>
                </nav>

                <div className="lora-admin-stats-grid">
                    <div className="lora-admin-glass-card lora-admin-stat-card">
                        <span className="lora-admin-stat-label">Total Enrollments</span>
                        <span className="lora-admin-stat-value">{safeRender(stats.totalEnrollments || stats.TotalEnrollments)}</span>
                    </div>
                    <div className="lora-admin-glass-card lora-admin-stat-card">
                        <span className="lora-admin-stat-label">Success Payments</span>
                        <span className="lora-admin-stat-value" style={{ color: 'var(--success)' }}>
                            {safeRender(stats.totalPaid || stats.TotalPaid)}
                        </span>
                    </div>
                    <div className="lora-admin-glass-card lora-admin-stat-card">
                        <span className="lora-admin-stat-label">Pending / Initiated</span>
                        <span className="lora-admin-stat-value" style={{ color: 'var(--warning)' }}>
                            {safeRender(stats.totalPending || stats.TotalPending)}
                        </span>
                    </div>
                    <div className="lora-admin-glass-card lora-admin-stat-card">
                        <span className="lora-admin-stat-label">Total Revenue</span>
                        <span className="lora-admin-stat-value">
                            {formatCurrency(stats.totalRevenue || stats.TotalRevenue)}
                        </span>
                    </div>
                </div>

                <div className="lora-admin-glass-card" style={{ padding: '30px', textAlign: 'center' }}>
                    <h3 style={{ margin: 0 }}>Welcome to Learnorama HQ</h3>
                    <p style={{ color: 'var(--text-secondary)' }}>Navigate through the tabs to manage your students and payments.</p>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
